import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DigitalBusinessCardMaker = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to the main Card Builder page
    navigate('/card-builder', { replace: true });
  }, [navigate]);

  // Show a brief loading state while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-amber-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to Card Builder...</p>
      </div>
    </div>
  );
};

export default DigitalBusinessCardMaker;
